import type { MesajTonu, TeklifTaslagi } from './tipler';

/** Taslak şemasında olmayan ek ekran durumu (eski kayıtlarda yok: varsayılan kullanılır). */
export interface EkranEki {
  readonly destinasyon?: string | null;
  readonly pdfDili?: 'tr' | 'en';
  readonly ton?: MesajTonu;
}

/** Tarayıcıda müşteri başına ekran taslağı (03.11.2026). Yalnız ekran durumu saklanır; parola ve jeton yok. */
export const TASLAK_OMRU_MS = 14 * 24 * 60 * 60 * 1000;
export const TASLAK_AZAMI_KARAKTER = 1_500_000;

/** `Storage` alt kümesi: testte düz nesneyle, tarayıcıda localStorage ile çalışır. */
export interface TaslakDeposu {
  getItem(anahtar: string): string | null;
  setItem(anahtar: string, deger: string): void;
  removeItem(anahtar: string): void;
}

export interface SaklananTaslak {
  readonly surum: 1;
  readonly kayitMs: number;
  readonly taslak: TeklifTaslagi;
  readonly ekran?: EkranEki;
}

export const taslakAnahtari = (musteriId: string): string => `hizliTeklif:taslak:${musteriId}`;

export type TaslakYazmaSonucu = 'yazildi' | 'buyuk' | 'hata';

export function taslakYaz(depo: TaslakDeposu, musteriId: string, taslak: TeklifTaslagi, simdiMs: number, ekran?: EkranEki): TaslakYazmaSonucu {
  const metin = JSON.stringify({ surum: 1, kayitMs: simdiMs, taslak, ...(ekran === undefined ? {} : { ekran }) } satisfies SaklananTaslak);
  if (metin.length > TASLAK_AZAMI_KARAKTER) return 'buyuk';
  try {
    depo.setItem(taslakAnahtari(musteriId), metin);
    return 'yazildi';
  } catch {
    return 'hata';
  }
}

/** Süresi geçmiş ya da bozuk kaydı siler ve null döner. */
export function taslakOku(depo: TaslakDeposu, musteriId: string, simdiMs: number): SaklananTaslak | null {
  const anahtar = taslakAnahtari(musteriId);
  try {
    const metin = depo.getItem(anahtar);
    if (metin === null) return null;
    const v = JSON.parse(metin) as Partial<SaklananTaslak> | null;
    const gecerli = v !== null && typeof v === 'object' && v.surum === 1 && typeof v.kayitMs === 'number' && typeof v.taslak === 'object' && v.taslak !== null
      && simdiMs - v.kayitMs <= TASLAK_OMRU_MS && v.kayitMs <= simdiMs + 60_000;
    if (!gecerli) { depo.removeItem(anahtar); return null; }
    return v as SaklananTaslak;
  } catch {
    taslakSil(depo, musteriId);
    return null;
  }
}

export function taslakSil(depo: TaslakDeposu, musteriId: string): void {
  try { depo.removeItem(taslakAnahtari(musteriId)); } catch { /* depo kapalı: sessiz geç */ }
}
